import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles({
  customMarker: {
    '& div.marker-pin': {
      width: 26,
      height: 26,
      border: '2px #ffffff solid',
      borderRadius: '50%',
      position: 'absolute',
      left: '50%',
      top: '50%',
      margin: '-13px 0 0 -13px',
      boxShadow: '0 1px 4px rgba(0,0,0,0.4)',
    },

    '& b': {
      position: 'absolute',
      width: 26,
      fontSize: 13,
      color: '#ffffff',
      left: 0,
      right: 0,
      margin: '-7px auto 0',
      top: '50%',
      textAlign: 'center',
    },
  },

  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '12px 20px',
  },

  legend: {
    maxHeight: 460,
    overflowY: 'auto',
    padding: '8px 12px',
  },

  legendItem: {
    display: 'flex',
    alignItems: 'center',
    gap: 6,
    cursor: 'pointer',
  },

  legendChip: {
    color: '#fff',
    borderRadius: 999,
    padding: '2px 10px',
    fontSize: 12,
    fontWeight: 600,
    whiteSpace: 'nowrap',
  },

  legendMeta: {
    fontSize: 12,
    color: '#6b7686',
    marginLeft: 44,
    marginTop: -8,
    marginBottom: 4,
  },
});
